import { createFileRoute, notFound } from '@tanstack/react-router';
import { RouteName } from '@mews-commander/enums';
import { areNewActionLogsEnabled, getCurrentEnterpriseSubscriptionId } from '@mews-commander/legacy-entities';
import { initializeOrderItemActionLog, OrderItemActionLogPage } from '@mews-commander/modules/src/modules/actionLogs';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/OrderItem/ActionLog/$id')({
    loader: async ({
        params: { id },
        context: {
            dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch,
            getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState,
        },
    }) => {
        await initializeOrderItemActionLog({ dispatch, getState }, { id });

        const state = getState();
        const subscriptionId = getCurrentEnterpriseSubscriptionId(state);
        if (!areNewActionLogsEnabled(state, { subscriptionId })) {
            throw notFound();
        }
    },
    component: Component,
    staticData: {
        routeName: RouteName.OrderItemActionLog,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { id } = Route.useParams();
    return <OrderItemActionLogPage orderItemId={id} />;
}
